import type { Appointment, Owner, Pet } from "../types";

export function normalizeText(value: string) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function normalizePhone(value: string) {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 9) return `48${digits}`;
  return digits;
}

export function displayPhone(value: string) {
  const digits = normalizePhone(value);
  return digits.length === 11 ? `+${digits}` : value.trim();
}

export function matchesAppointment(query: string, _appointment: Appointment, pet: Pet, owner: Owner) {
  const normalizedQuery = normalizeText(query);
  if (!normalizedQuery) return true;

  const textMatch = [pet.name, owner.fullName].some((value) => normalizeText(value).includes(normalizedQuery));
  const phoneQuery = normalizePhone(query);
  const phoneMatch = phoneQuery.length > 0 && normalizePhone(owner.phone).includes(phoneQuery);

  return textMatch || phoneMatch;
}
